
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { RefreshCw, Edit, Trash2 } from "lucide-react";
import { ElfScene } from "@/components/tools/scene-generator/types";

interface SceneListProps {
  scenes: ElfScene[];
  isLoading: boolean;
  onEdit: (scene: ElfScene) => void;
  onDelete: (id: string) => void;
}

const SceneList: React.FC<SceneListProps> = ({ scenes, isLoading, onEdit, onDelete }) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Title</TableHead>
          <TableHead>Difficulty</TableHead>
          <TableHead>Time</TableHead>
          <TableHead>Items</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          <TableRow>
            <TableCell colSpan={5} className="text-center py-4">
              <RefreshCw className="h-5 w-5 animate-spin mx-auto" />
            </TableCell>
          </TableRow>
        ) : scenes.length === 0 ? (
          <TableRow>
            <TableCell colSpan={5} className="text-center py-4">
              No scenes found. Create your first scene above.
            </TableCell>
          </TableRow>
        ) : (
          scenes.map(scene => (
            <TableRow key={scene.id}>
              <TableCell className="font-medium">{scene.title}</TableCell>
              <TableCell>{scene.difficulty}</TableCell>
              <TableCell>{scene.time_required || "—"}</TableCell>
              <TableCell>{scene.required_items.length} items</TableCell>
              <TableCell className="text-right">
                <div className="flex justify-end gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onEdit(scene)}
                  >
                    <Edit className="h-4 w-4" />
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onDelete(scene.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};

export default SceneList;
